import { FC } from 'react';
import styled from '@emotion/styled';
import { SectionListWrapper, SectionHeaderRow, SectionTitle } from './styles';
import SubscriptionCard from './SubscriptionCard';
import type { SubscriptionProduct } from './SubscriptionCard';
const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 0 16px 16px;
`;
interface Props {
  subscriptions: SubscriptionProduct[];
  sectionTitle?: string;
  onSubscribe: (subscription: SubscriptionProduct) => void;
  className?: string;
}
const SubscriptionList: FC<Props> = ({
  subscriptions,
  sectionTitle,
  onSubscribe,
  className
}) => {
  if (subscriptions.length === 0) return null;
  return <SectionListWrapper className={className} data-sentry-element="SectionListWrapper" data-sentry-component="SubscriptionList" data-sentry-source-file="SubscriptionList.tsx">
      <SectionHeaderRow data-sentry-element="SectionHeaderRow" data-sentry-source-file="SubscriptionList.tsx">
        <SectionTitle data-sentry-element="SectionTitle" data-sentry-source-file="SubscriptionList.tsx">{sectionTitle}</SectionTitle>
      </SectionHeaderRow>
      <GridWrapper data-sentry-element="GridWrapper" data-sentry-source-file="SubscriptionList.tsx">
        {subscriptions.map(sub => <SubscriptionCard key={sub.moduleId} product={sub} onClick={() => onSubscribe(sub)} />)}
      </GridWrapper>
    </SectionListWrapper>;
};
export default SubscriptionList;